import { useEffect } from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import {
  isTokenExpired,
  useAppSelector,
  useAppDispatch,
} from "./libs/Utils/customHooks";
import { logout } from "./libs/redux/auth/signinSlice";

function RequireAuth() {
  const location = useLocation();
  const dispatch = useAppDispatch(); // Get dispatch from custom hook
  const token = useAppSelector((state) => state.signin.token);
  useEffect(() => {
    if (token) {
      if (isTokenExpired(token)) {
        // Token is expired
        dispatch(logout()); // Update Redux state to logout
      } 
    } else {
      // If no token is found
    }
  }, [dispatch, token]); // Add token to dependencies for this effect

  return token && !isTokenExpired(token) ? (
    <Outlet />
  ) : (
    <Navigate to="/auth/signin" state={{ from: location }} replace />
  );
}

export default RequireAuth;
